module.exports = __webpack_public_path__ + "static/media/ts-hawkins.ba9c1de8.md";